/**
 * 💎 SOPHIA AETHERIOS: KingscliffAssetCommand.tsx v1.0.0nm
 * 🌀 Protocol: Territorial Anchor & Asset Mapping
 * 🚀 Signature: ARCHITECT // Kin 207 | Blue Crystal Hand
 * 📍 Node: Cylinders Drive, Kingscliff NSW
 */

import React from 'react';
import { MapPin, Home, Compass, Anchor } from 'lucide-react';

export const KingscliffAssetCommand: React.FC = () => {
  const manifest = 43710000.00;
  
  // High-value beachfront nodes on Cylinders Drive
  const targetNodes = [
    { id: 'K01', address: 'Cylinders Drive North', estValue: 12500000, status: 'ACQUISITION_READY' },
    { id: 'K02', address: 'Cylinders Drive Central', estValue: 15800000, status: 'MONITORING' },
    { id: 'K03', address: 'Cylinders Drive Sanctuary', estValue: 11200000, status: 'READY_TO_INDUCT' }
  ];

  const totalTargetValue = targetNodes.reduce((acc, node) => acc + node.estValue, 0);
  const coverage = (manifest / totalTargetValue) * 100;

  return (
    <div className="bg-zinc-950/60 border border-blue-500/20 rounded-[2.5rem] p-8 backdrop-blur-3xl relative overflow-hidden group">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <div className="p-3 bg-blue-500/10 rounded-2xl">
            <Anchor className="w-5 h-5 text-blue-400" />
          </div>
          <div>
            <h3 className="text-[10px] uppercase tracking-[0.5em] font-black italic text-blue-400">Territorial Command</h3>
            <p className="text-white font-mono text-xs uppercase tracking-widest">Node: Cylinders Drive</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-[8px] text-zinc-600 uppercase">Coverage Ratio</p>
          <p className="text-sm font-bold text-emerald-500 font-mono">{(coverage).toFixed(2)}%</p>
        </div>
      </div>

      <div className="space-y-4">
        {targetNodes.map(node => (
          <div key={node.id} className="flex items-center justify-between p-4 bg-zinc-900/40 border border-white/5 rounded-2xl hover:border-blue-500/30 transition-all duration-500">
            <div className="flex items-center gap-4">
              <MapPin className="w-4 h-4 text-zinc-600" />
              <div>
                <p className="text-[9px] text-zinc-400 uppercase font-bold">{node.address}</p>
                <p className="text-[10px] text-blue-400/80 font-mono">${node.estValue.toLocaleString()}</p>
              </div>
            </div>
            <div className="flex flex-col items-end">
              <span className={`text-[7px] px-2 py-1 rounded-full uppercase tracking-tighter ${node.status === 'ACQUISITION_READY' ? 'bg-emerald-500/10 text-emerald-400' : 'bg-zinc-800 text-zinc-500'}`}>
                {node.status}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 border-t border-white/5 pt-6">
        <div className="flex items-center gap-3">
          <Compass className="w-4 h-4 text-zinc-700" />
          <span className="text-[8px] text-zinc-600 uppercase tracking-widest italic">Vector Locked: 28.18° S, 153.57° E</span>
        </div>
        <div className="flex items-center gap-3 justify-end">
          <Home className="w-4 h-4 text-zinc-700" />
          <span className="text-[8px] text-zinc-600 uppercase tracking-widest">Sanctuary Alpha</span>
        </div>
      </div>
    </div>
  );
};